let API_BASE_URL = '';
if(process.env.NODE_ENV === 'development') {
    API_BASE_URL = 'http://localhost:3001'
}else {
    API_BASE_URL = process.env.REACT_APP_API_URL || ''; 
}

// console.log(API_BASE_URL);
// console.log(process.env);
export default API_BASE_URL;
